import dayjs from 'dayjs'

const config = {
  rowSelection: false,
  search: false,
  scroll: {
    y: 'calc(100vh - 510px)',
  },
  columns: [
    {
      title: '线索ID',
      dataIndex: 'id',
      render: 'clueIdRender',
      width: 190,
      fixed: 'left',
    },
    {
      title: '姓名',
      dataIndex: 'name',
      width: 100,
    },
    {
      title: '手机号码',
      dataIndex: 'phone',
      width: 140,
      render: 'checkPhoneRender',
    },
    {
      title: '楼盘',
      dataIndex: 'buildingName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '线索来源',
      dataIndex: 'channelName',
      width: 200,
      ellipsis: true,
    },
    {
      title: '线索归属',
      dataIndex: 'orgName',
      width: 150,
    },
    {
      title: '云客服',
      dataIndex: 'seat',
      width: 120,
      render: (text: string) => text || '-',
    },
    {
      title: '营销员',
      dataIndex: 'sales',
      width: 120,
      render: (text: string) => text || '-',
    },
    {
      title: '首访时间',
      dataIndex: 'firstDate',
      width: 120,
      render: (text: string) => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'),
    },
    {
      title: '最近跟进时间',
      dataIndex: 'lastFollowTime',
      width: 120,
      render: (text: string) => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'),
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      width: 120,
      render: (text: string) => (text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-'),
    },
    {
      title: '状态',
      dataIndex: 'statusName',
      width: 120,
      render: 'statusRender',
    },
  ],
  footer: false,
}

export default config
